export default {
  'goldkid-opened:title': 'Балаға арналған Kaspi Gold ашылды!',
  'goldkid-opened:title-AB': 'Бөлімшеге барып карта алыңыз',
  'goldkid-opened-steps:title': 'Балаға арналған Kaspi Gold картасын пайдалана бастау үшін:',
  'goldkid-opened-steps:title-AB': 'Балаға арналған Kaspi Gold картасын алу үшін',
  'goldkid-opened-steps:step1': 'Кез келген <a class="link-500 text-action-link" href="https://kaspi.kz/maps/cardomats/">Kaspi Картоматқа</a> барыңыз',
  'goldkid-opened-steps:step2': 'QR көмегімен карта алыңыз',
  'goldkid-opened-steps:step3': 'Kaspi.kz қосымшасында баланың картасына PIN-код қойыңыз',
  'goldkid-opened-steps:step4': 'Карта мен  PIN-кодты балаға беріңіз',
  'goldkid-opened:btn': 'Kaspi.kz бас бетіне қайту',
  'goldkid-opened:btn--AB': 'Жақын маңдағы Kaspi.kz бөлімшесі',
  'goldkid-open:btn-qr': 'Kaspi QR бөліміне өту',
  'goldkid-open:btn-download': 'Көшіріп алуға сілтеме жолдау',
  'goldkid-open:btn-goldkid': 'Балаға арналған Kaspi Gold бөліміне өту',
  'goldkid-open:title-re-release': 'Балаға&nbsp;арналған&nbsp;Kaspi&nbsp;Gold картасын алу үшін:'
}
